var map = {
	"./Curve.png": 787,
	"./arrowIcon.png": 788,
	"./bSwap-Icon.png": 789,
	"./backBTN.png": 259,
	"./binance-logo.png": 790,
	"./bnb-icon.png": 105,
	"./bnbRedioICON.png": 791,
	"./bnbSmallIcon.png": 792,
	"./bnbSmallIcon02.png": 793,
	"./cakeSmallIcon.png": 794,
	"./chains/chain-1.png": 237,
	"./chains/chain-10.png": 246,
	"./chains/chain-11.png": 247,
	"./chains/chain-12.png": 248,
	"./chains/chain-13.png": 249,
	"./chains/chain-14.png": 250,
	"./chains/chain-15.png": 251,
	"./chains/chain-16.png": 252,
	"./chains/chain-17.png": 253,
	"./chains/chain-18.png": 254,
	"./chains/chain-19.png": 255,
	"./chains/chain-2.png": 238,
	"./chains/chain-20.png": 256,
	"./chains/chain-21.png": 257,
	"./chains/chain-22.png": 258,
	"./chains/chain-3.png": 239,
	"./chains/chain-4.png": 240,
	"./chains/chain-5.png": 241,
	"./chains/chain-6.png": 242,
	"./chains/chain-7.png": 243,
	"./chains/chain-8.png": 244,
	"./chains/chain-9.png": 245,
	"./close-icon.png": 79,
	"./closeBTN.png": 62,
	"./coinicon-defiswap.png": 795,
	"./coinicon-miniswap.png": 796,
	"./coinicon-uniswap-v3.png": 797,
	"./coinicon-uniswap.png": 798,
	"./compound-finance.png": 799,
	"./cwICON-01.png": 260,
	"./cwICON-02.png": 261,
	"./cwICON-03.png": 262,
	"./cwICON-04.png": 263,
	"./darkLogo.png": 800,
	"./dex-mdex.png": 801,
	"./dex-shiba.png": 802,
	"./dex-wault.png": 803,
	"./dexIcon-01.png": 218,
	"./dexIcon-010.png": 227,
	"./dexIcon-011.png": 228,
	"./dexIcon-012.png": 229,
	"./dexIcon-013.png": 230,
	"./dexIcon-014.png": 231,
	"./dexIcon-015.png": 232,
	"./dexIcon-016.png": 233,
	"./dexIcon-017.png": 234,
	"./dexIcon-018.png": 235,
	"./dexIcon-019.png": 236,
	"./dexIcon-02.png": 219,
	"./dexIcon-03.png": 220,
	"./dexIcon-04.png": 221,
	"./dexIcon-05.png": 222,
	"./dexIcon-06.png": 223,
	"./dexIcon-07.png": 224,
	"./dexIcon-08.png": 225,
	"./dexIcon-09.png": 226,
	"./eth-icon.png": 139,
	"./ethRedioICON.png": 804,
	"./etherLOGO.png": 805,
	"./ethereum-logo.png": 806,
	"./exclamation.png": 807,
	"./fighter-icon.png": 808,
	"./footerLink_icon.png": 809,
	"./ftmIcon.png": 810,
	"./logo-icon.png": 811,
	"./logo-without-text.png": 812,
	"./logo.png": 813,
	"./mainbg01.png": 368,
	"./mdex-icon.png": 814,
	"./metamask.png": 815,
	"./mngTokenICO-01.png": 816,
	"./mngTokenICO-02.png": 817,
	"./mngTokenICO-03.png": 818,
	"./mngTokenICO-04.png": 819,
	"./page1.png": 820,
	"./page10.png": 821,
	"./page11.png": 822,
	"./page12.png": 823,
	"./page13.png": 824,
	"./page14.png": 825,
	"./page15.png": 826,
	"./page16.png": 827,
	"./page17.png": 828,
	"./page18.png": 829,
	"./page19.png": 830,
	"./page2.png": 831,
	"./page20.png": 832,
	"./page21.png": 833,
	"./page22.png": 834,
	"./page24.png": 835,
	"./page25.png": 836,
	"./page26.png": 837,
	"./page28.png": 838,
	"./page29.png": 839,
	"./page3.png": 840,
	"./page31.png": 841,
	"./page32.png": 842,
	"./page33.png": 843,
	"./page34.png": 844,
	"./page35.png": 845,
	"./page36.png": 846,
	"./page37.png": 847,
	"./page38.png": 848,
	"./page39.png": 849,
	"./page4.png": 850,
	"./page40.png": 851,
	"./page41.png": 852,
	"./page42.png": 853,
	"./page43.png": 854,
	"./page44.png": 855,
	"./page45.png": 856,
	"./page46.png": 857,
	"./page47.png": 858,
	"./page48.png": 859,
	"./page49.png": 860,
	"./page5.png": 861,
	"./page50.png": 862,
	"./page51.png": 863,
	"./page52.png": 864,
	"./page53.png": 865,
	"./page54.png": 866,
	"./page55.png": 867,
	"./page56.png": 868,
	"./page57.png": 869,
	"./page58.png": 870,
	"./page59.png": 871,
	"./page60.png": 872,
	"./page61.png": 873,
	"./page62.png": 874,
	"./page7.png": 875,
	"./page8.png": 876,
	"./page9.png": 877,
	"./ploygon-logo.png": 878,
	"./polygon.png": 879,
	"./selectTkn-01.png": 880,
	"./selectTkn-02.png": 881,
	"./selectTkn-03.png": 882,
	"./selectTkn-04.png": 883,
	"./selectTkn-05.png": 884,
	"./selectTkn-06.png": 885,
	"./selectTkn-07.png": 886,
	"./selectTkn-08.png": 887,
	"./serum-dex.png": 888,
	"./shibaswap-icon.png": 889,
	"./smBNB-icon.png": 890,
	"./spookyswap.png": 891,
	"./swapBICON-01.png": 892,
	"./swapBICON-02.png": 893,
	"./swapSICON-01.png": 894,
	"./swapSICON-02.png": 895,
	"./swapTitleIcon-01.png": 896,
	"./swapTitleIcon-02.png": 897,
	"./swapTitleIcon-03.png": 898,
	"./swapTitleIcon-04.png": 899,
	"./tableICON-01.png": 900,
	"./tableICON-010.png": 901,
	"./tableICON-011.png": 902,
	"./tableICON-02.png": 903,
	"./tableICON-03.png": 904,
	"./tableICON-04.png": 905,
	"./tableICON-05.png": 906,
	"./tableICON-06.png": 907,
	"./tableICON-07.png": 908,
	"./tableICON-08.png": 909,
	"./tableICON-09.png": 910,
	"./tenex.png": 161,
	"./traderjoe.png": 911,
	"./unicornIco.png": 216,
	"./wault-icon.png": 912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 786;